import React, { useState, useEffect, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../images/logo/logo.svg";
import LogoLight from "../../images/logo/logo-light.svg";
import BannerImg from "../../images/logo/banner.png";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import "./navbar.css";
import "../style.css";
import "./top-drawer.css";
import menuData from "./nav-list";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import Switch from "@mui/material/Switch";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import FormControlLabel from "@mui/material/FormControlLabel";

function TopDrawer() {
	const location = useLocation();
	const [scrollBgColor, setScrollBgColor] = useState("top-menu top-pos");
	const [banner, setBanner] = useState(false);
	const [shadowpos, setShadowpos] = useState(null);
	const [menuPos, setMenuPos] = useState([]);
	const [showSubmenu, setShowSubmenu] = useState(false);
	const [submenu, setSubmenu] = useState([]);
	const [submenuList, setSubmenuList] = useState([]);
	const [checked, setChecked] = React.useState(false);
	const [checked2, setChecked2] = React.useState(false);
	const [menuTitle, setMenuTitle] = useState("");

	const handleChange = () => {
		setChecked((prev) => !prev);
		setChecked2(false);
	};
	const handleChange2 = () => {
		setChecked2((prev) => !prev);
	};

	const [state, setState] = useState({
		right: false,
	});

	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}
		setState({ ...state, [anchor]: open });
	};

	const closeDrawer = () => {
		setState({ ...state, ["right"]: false });
	};

	useEffect(() => {
		const positions = [];

		menuData.forEach((item) => {
			const liElement = document.getElementById(item.id);

			if (liElement) {
				const rect = liElement.getBoundingClientRect().left;
				positions.push({ link: item.link, pos: rect });
			}
		});

		setMenuPos(positions);
	}, []);

	useEffect(() => {
		if (menuPos.length > 1) setShadowposDefault();
	}, [menuPos]);

	const setShadowposDefault = () => {
		switch (true) {
			case location.pathname.includes(menuPos[3].link):
				setShadowpos(menuPos[3].pos);
				break;
			case location.pathname.includes(menuPos[2].link):
				setShadowpos(menuPos[2].pos);
				break;
			case location.pathname.includes(menuPos[1].link):
				setShadowpos(menuPos[1].pos);
				break;
			default:
				setShadowpos(menuPos[0].pos);
		}
	};
	const icon = (
		<Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>
			<svg>
				<Box
					component="polygon"
					points="0,100 50,00, 100,100"
					sx={{
						fill: (theme) => theme.palette.common.white,
						stroke: (theme) => theme.palette.divider,
						strokeWidth: 1,
					}}
				/>
			</svg>
		</Paper>
	);

	const showMobileMenu = (item) => {
		setMenuTitle(item.title);
		setSubmenu(item.submenu);
		handleChange();
	};

	const showSubList = (subitem) => {
		if (subitem.list) {
			setSubmenuList(subitem);
			handleChange2();
		} else {
			closeDrawer();
		}
	};

	const list = (anchor) => (
		<Box
			sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
			role="presentation"
			className="menu-drawer"
		>
			<List className="menu-section-mobile">
				{menuData.map((item) => (
					<ListItem key={item.id}>
						<span className="menu-title">
							{item.submenu && item.submenu.length > 0 ? (
								<>
									<Link
										to={item.link}
										className="menu_mobile"
										onClick={() => showMobileMenu(item)}
									>
										{item.title}
									</Link>
								</>
							) : (
								<Link
									onClick={() => closeDrawer()}
									to={item.link}
									className="menu_mobile"
								>
									{item.title}
								</Link>
							)}
						</span>
					</ListItem>
				))}
			</List>
		</Box>
	);

	useEffect(() => {
		// console.log("location.pathname", location.pathname);
		if (
			location.pathname == "/" ||
			location.pathname == "/produkt" ||
			location.pathname == "/service"
		) {
			setBanner(false);
		} else {
			setBanner(true);
		}
		window.scrollTo(-100, -100);
	}, [location.pathname, location.hash]);

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			const threshold = 100;

			if (scrollPosition > threshold) {
				setScrollBgColor("top-menu top-pos-not");
			} else {
				setScrollBgColor("top-menu top-pos");
			}
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [location.pathname]);

	const onHoverPos = (e) => {
		const rect = e.target.getBoundingClientRect();
		setShadowpos(rect.left);
	};

	return (
		<>
			<div className={scrollBgColor}>
				<div className="top-menu-content">
					<div className="logo">
						<Link onClick={() => closeDrawer()} to="/" className="menu_link">
							<img
								src={scrollBgColor === "top-menu top-pos" ? LogoLight : Logo}
								alt=""
								className="logo-img"
							/>
						</Link>
					</div>
					<div className="menu-name dropdown">
						<div className="mobile-view h-100 ">
							{["right"].map((anchor) => (
								<Fragment key={anchor}>
									{state.right ? (
										<Button onClick={toggleDrawer("right", false)}>
											Close
										</Button>
									) : (
										<Button onClick={toggleDrawer("right", true)}>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="#1e4067"
												height="100%"
												className="bi bi-list"
												viewBox="0 0 16 16"
											>
												<path
													fillRule="evenodd"
													d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
												/>
											</svg>
										</Button>
									)}
									<Drawer
										anchor={anchor}
										open={state[anchor]}
										onClose={toggleDrawer(anchor, false)}
										className="drawer-class"
									>
										<div className="drawer-display d-flex flex-row w-100">
											<Collapse
												orientation="horizontal"
												in={!checked}
												width="100%"
											>
												{list(anchor)}
											</Collapse>

											<Collapse orientation="horizontal" in={checked}>
												<Box
													sx={{
														width:
															anchor === "top" || anchor === "bottom"
																? "auto"
																: 250,
													}}
													role="presentation"
												>
													<h2
														className="p-2 text-title-shadow text-wrap border border-2 border-bottom "
														onClick={handleChange}
													>
														{menuTitle}
													</h2>
													{checked ? (
														<div className="d-flex flex-row w-100">
															<Collapse
																orientation="horizontal"
																in={!checked2}
																sx={{ width: !checked2 ? 250 : 0 }}
															>
																<List className="menu-section-mobile">
																	{submenu.map((subitem) => (
																		<ListItem key={subitem.title}>
																			<span className="menu-title sub-cont">
																				<Link
																					to={subitem.link}
																					className="menu_mobile"
																					onClick={() => showSubList(subitem)}
																				>
																					{subitem.title}
																				</Link>
																			</span>
																		</ListItem>
																	))}
																</List>
															</Collapse>
															<Collapse
																orientation="horizontal"
																in={checked2}
																sx={{ width: 250 }}
															>
																<h3
																	className="p-4 text-wrap text-title-shadow border border-2 border-bottom "
																	onClick={handleChange2}
																>
																	{submenuList.title}
																</h3>
																<List className="menu-section-mobile">
																	{submenuList.list?.map((sub) => (
																		<ListItem key={sub.id}>
																			<span className="menu-title sub-cont">
																				<Link
																					to={sub.link}
																					className="menu_mobile"
																					onClick={closeDrawer}
																				>
																					{sub.label}
																				</Link>
																			</span>
																		</ListItem>
																	))}
																</List>
															</Collapse>
														</div>
													) : (
														""
													)}
												</Box>
											</Collapse>
										</div>
									</Drawer>
								</Fragment>
							))}
						</div>
						<ul id="main_menu" className="menu">
							{menuData.map((item) => (
								<li
									key={item.id}
									id={item.id}
									className="menu-hd"
									onMouseEnter={(e) => onHoverPos(e)}
									onMouseLeave={() => setShadowposDefault()}
								>
									<span className="menu-title">
										<Link to={item.link} className="menu_link">
											{item.title}
										</Link>
									</span>
									{item.submenu.length > 0 && (
										<ul className="dropdown-content">
											{item.submenu.map((subitem) => (
												<li key={subitem.title} className="dropdown-submenu">
													<Link
														to={subitem.link}
														className={
															subitem.list ? "menu_link_top" : "menu_link_top"
														}
													>
														{subitem.title}
													</Link>
													<div
														className={
															subitem.list
																? "nav-right-menu nav-right"
																: "nav-right-menu "
														}
													></div>
													{subitem.list ? (
														<div className="dropdown-side-sub d-flex">
															{subitem.list.map((sub) => (
																<Link
																	to={sub.link}
																	key={sub.id}
																	className="menu_link_top menu-high"
																>
																	{sub.label}
																</Link>
															))}
														</div>
													) : (
														""
													)}
												</li>
											))}
										</ul>
									)}
								</li>
							))}
						</ul>
						<div className="highlight" style={{ left: shadowpos }}></div>
					</div>
				</div>
			</div>
			{banner && (
				<div className="banner">
					<img src={BannerImg} alt="Banner" />
				</div>
			)}
		</>
	);
}

export default TopDrawer;
